import classNames from 'clsx'

import {
  ContentSizeEnum,
  type ContentSize,
  type ImagesContent as ImagesContentType,
} from '../../../../../shared/types'
import { parentMeta } from '../../type'
import styles from './ImagesContent.module.scss'
import { normalizeImageName } from '../../../../../shared/utils'
import { Alert } from '../../../../common'
import capitolNoirIcon from '../../../../../images/capitol-noir-icon.jpg'
import useImagesContent, { imgErrorItem } from './useImagesContent'

interface ImagesContentProps {
  parentMeta?: parentMeta
  content: ImagesContentType
  filePath?: string
  size?: ContentSize
  fallbackSrc?: string
}

const ImagesContent = (props: ImagesContentProps) => {
  const {
    parentMeta,
    filePath,
    content,
    size,
    fallbackSrc = capitolNoirIcon,
  } = props
  const { fileNames } = content
  const { erroredImages, handleError } = useImagesContent({ fallbackSrc })

  return (
    <div
      className={classNames(
        styles.imagesContentRoot,
        size === ContentSizeEnum.Small ? styles.small : ''
      )}
    >
      {fileNames.map((image, index) => (
        <img
          key={index}
          src={`${filePath}${image}`}
          alt={
            parentMeta?.title
              ? `${parentMeta?.id}-${image}`
              : normalizeImageName(image, true)
          }
          onError={(e) => handleError(e, index, `${filePath}${image}`)}
        />
      ))}
      {erroredImages.map((img: imgErrorItem) => (
        <Alert key={img.index} title="Image failed to load">
          {img.src}
        </Alert>
      ))}
    </div>
  )
}

export default ImagesContent
